export const PartnerLogos = () => {
  const logos = [
    "/trusted-logos/total.webp",
    "/trusted-logos/grow.png",
    "/trusted-logos/elgato.png",
    "/trusted-logos/utb.png",
    "/trusted-logos/2.png",
    "/trusted-logos/3.png",
    "/trusted-logos/1.png",
    "/trusted-logos/4.png",
    "/trusted-logos/6.png",
    "/trusted-logos/5.png",
    "/trusted-logos/8.png",
    "/trusted-logos/9.png",
    "/trusted-logos/giveinternet.png",
    "/trusted-logos/sawa.png",
    "/trusted-logos/nutreco.png",
    "/trusted-logos/tunga.png",
  ];

  return (
    <section className="py-8">
      <div className="flex flex-col md:flex-row items-center justify-start max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-[#f9f9f9] rounded-2xl py-6">
        <h1 className="text-gray-500 mb-4 md:mb-0 md:mr-4 text-lg md:text-xl flex-shrink-0">
          Trusted by:
        </h1>
        <div className="w-full overflow-hidden">
          <div className="flex w-max flex-nowrap animate-scroll">
            {/* First set of logos */}
            {logos.map((logo, index) => (
              <div
                key={`first-${index}`}
                className="flex-shrink-0 w-40 md:w-56 px-6 flex justify-center items-center"
              >
                <img
                  src={logo}
                  width={150}
                  height={150}
                  alt={`Trusted Partner ${index + 1}`}
                  className="object-contain max-h-24 opacity-70 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {logos.map((logo, index) => (
              <div
                key={`second-${index}`}
                className="flex-shrink-0 w-40 md:w-56 px-6 flex justify-center items-center"
              >
                <img
                  src={logo}
                  width={150}
                  height={150}
                  alt={`Trusted Partner ${index + 1}`}
                  className="object-contain max-h-24 opacity-70 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
